import { useEffect, useState } from "react";
import { LOADING_MESSAGES } from "../data/sampleQuestions";

/** How long each stage is shown before advancing. */
export const STAGE_INTERVAL_MS = 6000;

/**
 * The single staged loading-text mechanism, shared by every chat hook so they
 * cannot drift apart.
 *
 * A response can take 20-45 seconds, so the stages advance in order and hold
 * on the last one rather than looping back to the first — looping would make
 * a long wait look like it had restarted. The text clears as soon as the first
 * token of the response lands (`streaming`) or the request finishes.
 *
 * @param {boolean} loading  a request is in flight
 * @param {boolean} streaming  the response has started arriving
 * @returns {string} the current stage, or "" when nothing should be shown
 */
export const useStagedLoadingMessage = (loading, streaming) => {
  const [loadingMessage, setLoadingMessage] = useState("");

  useEffect(() => {
    if (!loading || streaming) {
      setLoadingMessage("");
      return;
    }

    let idx = 0;
    setLoadingMessage(LOADING_MESSAGES[idx]);
    const interval = setInterval(() => {
      if (idx >= LOADING_MESSAGES.length - 1) {
        clearInterval(interval);
        return;
      }
      idx += 1;
      setLoadingMessage(LOADING_MESSAGES[idx]);
    }, STAGE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [loading, streaming]);

  return loadingMessage;
};
